var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStructure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.182 11.454h-1.636V9a.818.818 0 00-.819-.818H9.818V6.545h1.636a.818.818 0 00.819-.818V.818A.818.818 0 0011.454 0H6.545a.818.818 0 00-.818.818v4.91a.818.818 0 00.818.817h1.637v1.637h-4.91A.818.818 0 002.456 9v2.454H.818a.818.818 0 00-.818.819v4.909A.818.818 0 00.818 18h4.91a.818.818 0 00.817-.818v-4.91a.818.818 0 00-.818-.818H4.091V9.819h9.818v1.636h-1.636a.818.818 0 00-.819.819v4.909a.818.818 0 00.819.818h4.909a.819.819 0 00.818-.818v-4.91a.818.818 0 00-.818-.818zM4.909 13.091v3.273H1.636V13.09H4.91zm2.455-8.182V1.636h3.272V4.91H7.364zm9 11.455H13.09V13.09h3.273v3.273z",
    fill: "#8A9AA7"
  })));
}
export default SvgStructure;